import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import Form from '@components/Form/Form';
import { Loading } from "@components/Loading";
import { createDonationVariables, updateDonationVariables } from "@api/graphql/types";

type formDataType = updateDonationVariables | createDonationVariables;

/**
 * For convenience we first fill these fields then pass them to the GraphQL-schema requests
 * E.g. active_from and active_to gets put into active: { active_from: string, active_to: string  }
 */
export interface DonationVariablesBeforeSubmit {
    name: string;
    cms_url: string;
    active_from: string;
    active_to: string;
}

type Props = {
    formData: formDataType,
    onSubmit: (formData: formDataType) => Promise<any>,
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: formDataType;
}

class DonationForm extends React.Component<Props, State> {
    public componentWillReceiveProps(props: Props) {
        this.setState({ formData: props.formData });
    }

    private validate = (): boolean => {
        return true;
    }

    private fields = () => {
        return [
            {
                id: 'default',
                fields: [
                    { name: 'name', type: 'text', props: { required: true } },
                    { name: 'cms_url', type: 'text', props: { required: true } },
                    { name: 'active_from', type: 'datetime', props: { required: true, alias: 'active' } },
                    { name: 'active_to', type: 'datetime', props: { required: true, alias: 'active' } },
                ],
            },
        ];
    }

    public render() {
        if (!this.props.formData) {
            return <Loading />;
        }

        return (
            <>
                <Form
                    fields={this.fields()}
                    formData={this.props.formData}
                    intlPrefix={'module.donation'}
                    validate={this.validate}
                    onSubmit={this.props.onSubmit}
                    redirectPath={Path.donation}
                />
            </>
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(DonationForm);



// WEBPACK FOOTER //
// ./src/modules/Donation/components/DonationForm.tsx